/**
 * Recently Viewed Products Manager
 * Tracks and displays recently viewed products using localStorage
 */

class RecentlyViewedManager {
  constructor() {
    this.storageKey = 'shinez_recently_viewed';
    this.maxItems = 12;
  }

  /**
   * Add a product to recently viewed
   */
  addProduct(productId, productHandle) {
    if (!productId || !productHandle) return;

    let viewed = this.getViewed();

    // Remove if already exists (to move to front)
    viewed = viewed.filter(item => item.id !== productId);

    // Add to front
    viewed.unshift({
      id: productId,
      handle: productHandle,
      timestamp: Date.now()
    });

    // Limit to maxItems
    viewed = viewed.slice(0, this.maxItems);

    // Save to localStorage
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(viewed));
    } catch (e) {
      console.error('Failed to save recently viewed:', e);
    }
  }

  /**
   * Get recently viewed products
   */
  getViewed() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Failed to load recently viewed:', e);
      return [];
    }
  }

  /**
   * Get product handles (excluding current product)
   */
  getViewedHandles(excludeHandle = null) {
    return this.getViewed()
      .filter(item => item.handle !== excludeHandle)
      .map(item => item.handle);
  }

  /**
   * Clear all recently viewed
   */
  clear() {
    try {
      localStorage.removeItem(this.storageKey);
    } catch (e) {
      console.error('Failed to clear recently viewed:', e);
    }
  }
}

// Initialize and track current product on product pages
document.addEventListener('DOMContentLoaded', () => {
  const manager = new RecentlyViewedManager();

  // Check if we're on a product page
  const productElement = document.querySelector('[data-product-id]');

  if (productElement) {
    const productId = productElement.dataset.productId;
    const productHandle = window.location.pathname.split('/').filter(Boolean).pop();

    if (productId && productHandle) {
      manager.addProduct(productId, productHandle);
    }
  }

  // Initialize recently viewed section if present
  const recentlyViewedGrid = document.querySelector('#recently-viewed-grid');

  if (recentlyViewedGrid) {
    initRecentlyViewedSection(manager, recentlyViewedGrid);
  }
});

/**
 * Initialize and populate the recently viewed section using Section Rendering API
 */
async function initRecentlyViewedSection(manager, gridElement) {
  const sectionElement = gridElement.closest('.recently-viewed-section');
  const carousel = sectionElement?.querySelector('carousel-slider');
  const sectionId = gridElement.dataset.sectionId;
  const gridCols = gridElement.dataset.grid || '4';

  if (!sectionElement) return;

  // Get current product handle to exclude it
  const currentHandle = window.location.pathname.split('/').filter(Boolean).pop();
  const handles = manager.getViewedHandles(currentHandle);

  // Hide section if no products to show
  if (handles.length === 0) {
    sectionElement.style.display = 'none';
    return;
  }

  try {
    // Use Section Rendering API to fetch rendered product cards
    const handlesParam = handles.slice(0, 8).join(',');
    const url = `/pages/recently-viewed?section_id=recently-viewed-ajax&product_handles=${encodeURIComponent(handlesParam)}&enable_carousel=true&grid=${gridCols}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }

    const html = await response.text();

    // Clear loading and insert rendered products
    gridElement.innerHTML = html;

    // Refresh carousel after products loaded
    if (carousel && typeof carousel.refresh === 'function') {
      setTimeout(() => {
        carousel.refresh();
      }, 100);
    }

    // Initialize any lazy scripts in the loaded content
    if (window.theme && window.theme.initLazyScript) {
      gridElement.querySelectorAll('[data-lazy-script]').forEach(el => {
        window.theme.initLazyScript(el);
      });
    }

  } catch (error) {
    console.error('Failed to load recently viewed products:', error);
    gridElement.innerHTML = '<div style="grid-column: 1 / -1; text-align: center; padding: 2rem; color: #d32f2f;">Failed to load products</div>';
  }
}

// Make manager available globally if needed
window.RecentlyViewedManager = RecentlyViewedManager;
